import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";

const accentStyles: Record<string, { bubble: string; text: string; hover: string }> = {
  primary: {
    bubble: "bg-primary-100 text-primary-700",
    text: "text-primary-700",
    hover: "hover:border-primary-300",
  },
  accent: {
    bubble: "bg-accent-100 text-accent-700",
    text: "text-accent-700",
    hover: "hover:border-accent-300",
  },
  secondary: {
    bubble: "bg-secondary-100 text-secondary-800",
    text: "text-secondary-800",
    hover: "hover:border-secondary-300",
  },
};

export default function CategorySection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-6 md:py-20 lg:px-10">
        <SectionHeading
          eyebrow="TOPICS"
          title="按主题找瓜，比刷热搜更快"
          desc="六个常驻栏目，覆盖从娱乐圈到生活日常的高频话题，每个栏目都有独立的线索入口。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => {
            const style = accentStyles[category.accent] ?? accentStyles.primary;
            return (
              <Reveal key={category.id} delay={index * 70}>
                <Link
                  to={`/hot?cat=${category.id}`}
                  className={`group flex h-full flex-col rounded-lg border border-background-300 bg-background-50 p-6 transition-colors ${style.hover}`}
                >
                  <div className="flex items-center justify-between">
                    <span
                      className={`flex h-11 w-11 items-center justify-center rounded-md text-xl ${style.bubble}`}
                    >
                      <i className={category.icon} aria-hidden="true" />
                    </span>
                    <span className="text-xs text-foreground-500">{category.count} 条线索</span>
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-7 text-foreground-600">{category.desc}</p>
                  <span
                    className={`mt-5 inline-flex items-center gap-1 text-sm transition-transform ${style.text}`}
                  >
                    进入栏目
                    <i
                      className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1"
                      aria-hidden="true"
                    />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}